import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Página de entrada quando o cliente escaneia o QR code de uma mesa. Valida o
// token, guarda a mesa/estabelecimento no localStorage (do mesmo jeito que o
// resto do fluxo do cliente já usa) e cai direto no cardápio — sem exigir
// cadastro, exceto em lanchonete universitária (`exige_cadastro`).
function MesaEntrada() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [erro, setErro] = useState('');

  useEffect(() => {
    const validarMesa = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const response = await fetch(`${API_URL}/mesa-publica/${token}`);
        const data = await response.json();

        if (!response.ok) {
          setErro(data.error || 'Mesa não encontrada.');
          return;
        }

        localStorage.setItem('estabelecimento_id', data.id_estabelecimento);
        localStorage.setItem('id_mesa', data.id_mesa);
        localStorage.setItem('mesa_token_qrcode', token);
        localStorage.setItem('mesa_exige_cadastro', data.exige_cadastro ? 'true' : 'false');

        navigate(`/estabelecimento/${data.id_estabelecimento}`, { replace: true });
      } catch (error) {
        setErro('Não foi possível validar a mesa. Tente novamente.');
      }
    };

    validarMesa();
  }, [token, navigate]);

  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <p>{erro || 'Carregando cardápio da mesa...'}</p>
    </div>
  );
}

export default MesaEntrada;
